import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React__default, { useState } from 'react';

const FallbackImage = (_a) => {
    var { fallbackImage, src } = _a, props = __rest(_a, ["fallbackImage", "src"]);
    // fallback image should only be defined if there's an error loading the original image
    const [fallbackImgSrc, setFallbackImgSrc] = useState(undefined);
    const imgSrc = fallbackImgSrc || src;
    return React__default.createElement("img", Object.assign({}, props, { onError: () => setFallbackImgSrc(fallbackImage), src: imgSrc }));
};

export { FallbackImage };
//# sourceMappingURL=FallbackImage.js.map
